import type { ReactElement } from 'react';
import { cn } from '../../../lib/cn';

type RubricCriterionRowProps = {
  title: string;
  descriptor?: string;
  selected?: boolean;
  onSelect?: () => void;
  className?: string;
};

export function RubricCriterionRow({
  title,
  descriptor,
  selected = false,
  onSelect,
  className,
}: RubricCriterionRowProps): ReactElement {
  const interactive = Boolean(onSelect);

  return (
    <button
      type="button"
      disabled={!interactive}
      onClick={onSelect}
      className={cn(
        'flex min-h-14 w-full flex-col justify-center gap-0.5 rounded-dg-control border px-3 py-2 text-left transition-colors',
        interactive &&
          'cursor-pointer hover:border-dg-accent-grade/40 hover:bg-dg-accent-gradeLight/50 dark:hover:bg-amber-950/30',
        selected
          ? 'border-dg-accent-grade bg-dg-accent-gradeLight/80 ring-2 ring-dg-accent-grade/30 dark:border-amber-600 dark:bg-amber-950/40'
          : 'border-slate-200/70 bg-slate-50/80 dark:border-slate-600/70 dark:bg-slate-800/40',
        !interactive && 'cursor-default',
        className
      )}
    >
      <div className="text-dg-body font-medium text-slate-900 dark:text-white">{title}</div>
      {descriptor ? (
        <div className="text-dg-secondary text-slate-600 dark:text-slate-400">{descriptor}</div>
      ) : null}
    </button>
  );
}
